import React from "react";
import { ReactComponent as Facebook } from "../../assets/svg/Landing/Facebook.svg";
import { ReactComponent as X } from "../../assets/svg/Landing/X.svg";
import { ReactComponent as Linkedin } from "../../assets/svg/Landing/Linkedin.svg";
import { ReactComponent as Pintrest } from "../../assets/svg/Landing/Pintrest.svg";
import { ReactComponent as Telegram } from "../../assets/svg/Landing/Telegram.svg";

const BlueSocial = () => {
  return (
    <div className="relative w-full h-10 bg-primary">
      <div className="flex flex-row p-3 justify-end space-x-4">
        <Telegram />
        <Linkedin />
        <Pintrest />
        <X />
        <Facebook />
      </div>
    </div>
  );
};

export default BlueSocial;
